export default "__VITE_ASSET__DAP1BQGJ__"